import { useEffect, useState } from "react";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { IConcreteBaseItem } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseItem";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

const ItemInventoryPopover = () => {

  const [items, setItems] = useState<IConcreteBaseItem[]>([]);

  useEffect(() => {
    async function getData() {
      const fetchedItems = await concreteBaseService.getConcreteBaseInputItems(true);
      setItems(fetchedItems);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div className="g-grid g-content concrete-base-item-inventory">
      {items && items.length > 0 ? items.map((item, index) => {
        return <div className="row" key={index}>
          <div className="col">
            <div className="bg-item center strong">
              <span>{item.latestItemCode}</span>
            </div>
          </div>
          <div className="col">
            <div className="bg-item">
              <span>{item.name}</span>
            </div>
          </div>
          <div className="col">
            <div className="bg-item strong">
              <span>{
                FormatNumberWithUnitOrNull(item.latestPricePerUnit, 'rsd')
              }</span>
            </div>
          </div>
          <div className="col">
            <div className="bg-item">
              <span>{item.latestQuantityUnit?.name}</span>
            </div>
          </div>
          <div className="col">
            <div className="bg-item">
              <InfoTooltip
                tooltip={item.canStayInRepository
                  ? 'galanterija' : 'beton'}
                element="span">{item.canStayInRepository ? 'g' : 'b'}
              </InfoTooltip>
            </div>
          </div>
        </div>
      })
        : <div className="concrete-base-item-inventory-fallback">
          Nema unetih sopstvenih proizvoda
        </div>}
    </div>
  );
};

export default ItemInventoryPopover;
